var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBarbell = function SvgBarbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M5.5 8.5h2v7h-2zM16.5 8.5h2v7h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 9.833v4.61M3.333 9.833v4.61M8.332 12h8",
    stroke: "#fff",
    strokeLinecap: "square"
  })));
};
export { SvgBarbell as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNS41IiB5PSI4LjUiIHdpZHRoPSIyIiBoZWlnaHQ9IjciIHN0cm9rZT0id2hpdGUiLz4KPHJlY3QgeD0iMTYuNSIgeT0iOC41IiB3aWR0aD0iMiIgaGVpZ2h0PSI3IiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMC42NjY3IDkuODMzMzRWMTQuNDQyNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMy4zMzI2OCA5LjgzMzM0VjE0LjQ0MjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTguMzMyMDMgMTJIMTYuMzMyIiBzdHJva2U9IndoaXRlIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo=";